import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { Impersonation } from 'src/app/shared/interfaces/support/impersonation/impersonation.interface'
import { environment } from 'src/environments/environment'

@Injectable({
    providedIn: 'root',
})
export class ImpersonationService {
    #httpClient = inject(HttpClient)

    startImpersonation(userId: number, companyId: number): Observable<Impersonation> {
        return this.#httpClient
            .post<ApiResponse<Impersonation>>(`${environment.baseUrl}impersonation/start`, {
                targetUserId: userId,
                targetUserCompanyId: companyId,
            })
            .pipe(map((response) => response.result))
    }

    stopImpersonation() {
        return this.#httpClient.post(`${environment.baseUrl}impersonation/stop`, {})
    }
}
